import React from "react"

import classNames from "classnames"

import { WithChildren } from "shared/types/WithChildren"
import { WithClassName } from "shared/types/WithClassName"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

import { Icon } from "../icon/Icon"
import { IconName } from "../icon/__generated__/IconName"
import "./styles/_image.scss"

export interface ImageProps extends WithClassName, WithChildren {
  isLoading?: boolean
}

export const Image = React.memo(
  ({ children, isLoading, className }: ImageProps) => (
    <div
      className={classNames(
        "image",
        { "image--loading": isLoading },
        className
      )}
    >
      <div className="image__content">{children}</div>
      {isLoading ? <Skeleton containerClassName="image__loader" /> : null}
      <div className="image__empty">
        <Icon name={IconName.NO_IMAGE} />
      </div>
    </div>
  )
)
